import type { ReactNode } from 'react';

/**
 * Centered "Coming soon" placeholder for surfaces that are wired into the nav
 * but not yet built (Schedule, Reports). Rendered inside a page's card shell.
 * Reused by both pages so the copy stays single-sourced.
 */
export function ComingSoon({
  icon,
  description,
}: {
  icon?: ReactNode;
  description?: string;
}) {
  // py-[138px] (276px total) is 148px more vertical space than the py-16
  // (128px) baseline, so the card is 148px taller.
  return (
    <section className="card-sm flex flex-col items-center justify-center text-center gap-3 py-[138px]">
      {icon && (
        <span
          className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center text-gray-400"
          aria-hidden="true"
        >
          {icon}
        </span>
      )}
      <h2 className="text-base font-semibold text-gray-900">Coming soon</h2>
      {description && <p className="text-sm text-gray-400 max-w-sm">{description}</p>}
    </section>
  );
}
